import * as _ from 'lodash';
import ICity = ZoneIQCalibration.ICity;
import { SimpleMapper } from './simple-mapper';
import { MunicipalityModel } from '../models/calibrations/municipality.model';
import { IMunicipalityModel } from '../interfaces/municipality-model.interface';
import { getGAPIDataSourceCategory } from 'src/shared/enums/data-source-category-enum';

export class MunicipalityMapper extends SimpleMapper<IMunicipalityModel, ICity> {
    constructor() {
        super();
        this.fromDTOFields = [
            'Id',
            'Name',
            'Description',
            'State',
            'UsePosition',
            'Latitude',
            'Longitude',
            'GridicsInstanceId',
            'ZoomLevel',
            'LogoPath',
            'Tiles3DURL',
            'Tiles3DAccessToken',
            'GridicsId',
            'ProjectsDataSourceCategory',
            'IndexStateLayerPRs',
            'importValidationResult'
        ];
        this.toDTOFields = this.fromDTOFields;
        this.entityConstructor = MunicipalityModel;
    }

    fromDTO(dto: ICity, params?: any): MunicipalityModel {
        if (!dto) {
            return dto;
        }

        const model = super.fromDTO(dto, params);
        model.parcelLevel = getGAPIDataSourceCategory(model.ProjectsDataSourceCategory);

        return model;
    }
}

export function municipalityMapperFactory(): MunicipalityMapper {
    return new MunicipalityMapper();
}
